import cx from 'classnames';
import { forwardRef } from 'react';
import type { MouseEventHandler, PropsWithChildren, ReactElement } from 'react';

import { Button } from '@trello/nachos/button';
import type { TestId } from '@trello/test-ids';

import styles from './IslandNavButton.less';

interface IslandNavButtonProps {
  className?: string;
  icon: ReactElement;
  isDisabled?: boolean;
  isPrimary?: boolean;
  isSelected?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  testId?: TestId;
  title?: string;
}

export const IslandNavButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<IslandNavButtonProps>
>(
  (
    {
      className,
      icon,
      isDisabled = false,
      isPrimary = false,
      isSelected = false,
      onClick,
      testId,
      title,
      children,
    },
    ref,
  ) => {
    return (
      <Button
        className={cx(styles.button, className, {
          [styles.primary]: isPrimary,
          [styles.selected]: isSelected,
        })}
        appearance="subtle"
        shouldFitContainer={true}
        isDisabled={isDisabled}
        onClick={onClick}
        ref={ref}
        title={title}
        testId={testId}
        iconBefore={
          children ? <span className={styles.icon}>{icon}</span> : undefined
        }
        role="checkbox"
        aria-checked={isSelected}
      >
        {!children ? icon : null}
        {isSelected && <span className={styles.indicator}></span>}
        {children}
      </Button>
    );
  },
);
